module.exports = __webpack_public_path__ + "static/media/withdraeico.7d918384.svg";